<template>
  <section>
    <!--工具条-->

    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addFormVisible = true">新增</el-button>
      <el-button type="primary" size="small" @click="removeData">删除</el-button>
    </el-col>

    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>
    <el-table :data="tableData"
              border
              @selection-change="selsChange"
              v-loading="listLoading">
      <el-table-column
        label="用户编号"
        prop="usid"
        align="center">
      </el-table-column>
      <el-table-column
        label="宠物姓名"
        prop="pet_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="宠物性别"
        prop="sex"
        align="center">
      </el-table-column>
      <el-table-column
        label="宠物生日"
        prop="birthday"
        align="center">
      </el-table-column>
      <el-table-column
        label="宠物介绍"
        prop="pet_intro"
        align="center">
      </el-table-column>
      <el-table-column
        label="宠物图片"
        prop="pet_pics"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="修改时间"
        prop="update_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="状态"
        prop="status"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        prop="labels"
        align="center">
        <template scope="scope">
          <el-button size="small" type="primary"  @click="editHandler(scope.row)">修改</el-button>
          <el-button size="small" type="primary"  @click="deleteHandler(scope.row.pet_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="200px" :rules="formRules" ref="addForm">
        <el-form-item label="用户编号" prop="usid">
          <el-col :span="16">
            <el-input v-model="addForm.usid" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物姓名" prop="pet_name">
          <el-col :span="16">
            <el-input v-model="addForm.pet_name" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物性别" prop="sex">
          <el-col :span="16">
            <el-input v-model="addForm.sex" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物生日" prop="birthday">
          <el-col :span="16">
            <el-input v-model="addForm.birthday" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物介绍" prop="pet_intro">
          <el-col :span="16">
            <el-input v-model="addForm.pet_intro" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物图片" prop="pet_pics">
          <el-col :span="16">
            <el-input v-model="addForm.pet_pics" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="创建时间" prop="create_time">
          <el-col :span="16">
            <el-input v-model="addForm.create_time" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="修改时间" prop="update_time">
          <el-col :span="16">
            <el-input v-model="addForm.update_time" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-col :span="16">
            <el-input v-model="addForm.status" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="200px" :rules="formRules" ref="editForm">
        <el-form-item label="用户编号" prop="usid">
          <el-col :span="16">
            <el-input v-model="editForm.usid" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物姓名" prop="pet_name">
          <el-col :span="16">
            <el-input v-model="editForm.pet_name" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物性别" prop="sex">
          <el-col :span="16">
            <el-input v-model="editForm.sex" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物生日" prop="birthday">
          <el-col :span="16">
            <el-input v-model="editForm.birthday" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物介绍" prop="pet_intro">
          <el-col :span="16">
            <el-input v-model="editForm.pet_intro" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="宠物图片" prop="pet_pics">
          <el-col :span="16">
            <el-input v-model="editForm.pet_pics" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="创建时间" prop="create_time">
          <el-col :span="16">
            <el-input v-model="editForm.create_time" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="修改时间" prop="update_time">
          <el-col :span="16">
            <el-input v-model="editForm.update_time" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-col :span="16">
            <el-input v-model="editForm.status" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {}
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/pets/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.addForm);
              //异步请求
              this.$axios.post(config.api_url + '/pets',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },

      //操作删除
      deleteHandler(id){
        if(id !=0){
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/pets/delete/' + id
            ).then(response => {
              if(response.data.state) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(error => {
              this.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }

      },

      //勾选删除数据
      removeData() {
        if(this.selectRow.length > 0) {
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if(this.selectRow.length == 1) {
              this.$axios.delete(config.api_url + '/pets/delete/' + this.selectRow[0].pet_id
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '删除异常，请联系管理员',
                  type: 'error'
                });
              });
            } else {
              let ids = '',
                para = {};
              for(let row of this.selectRow) {
                ids += row.pet_id + ','
              }
              ids = ids.substring(0,ids.length - 1);
              this.$axios.delete(config.api_url + '/pets/batch/delete/' + ids
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '删除异常，请联系管理员',
                  type: 'error'
                });
              });
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          this.$message({
            message: '请选择一条数据操作',
            type: 'warning'
          });
        }
      },
      //获取选中的数据
      selsChange(row) {
        this.selectRow = row
      },

      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = row
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.editForm);
              //异步请求
              this.$axios.put(config.api_url + '/pets',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// Pets.vue?f6302642